import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
    DataTable, Table, TableBody, TableCell,
    TableContainer, TableHead, TableHeader, TableRow,
    InlineLoading, Pagination, TableToolbarContent,
    TableToolbarSearch, Button, TableToolbar
} from "@carbon/react";
import { useSorting } from "../../../modules/hooks/sorting";

const PAGE_SIZE = 7;

const PerformancePreviousTurn = () => {
    const { estado_turno_prev } = useSelector(state => state.performance) ?? {};
    const filteredRows = (estado_turno_prev ?? []).filter(
        item =>
            item.ultimo_registro !== "NaT" &&
            item.ultimo_registro !== null
    );
    const [page, setPage] = useState(1);
    const _headers = [
        { header: 'Patente', key: 'patent', sortDirection: 'DESC' },
        { header: 'Nombre', key: 'name', sortDirection: 'DESC' },
        { header: 'Apellido', key: 'surname', sortDirection: 'DESC' },
        { header: 'Hora Detectada', key: 'ultimo_registro', sortDirection: 'DESC', isDefaultSortable: true },
        { header: 'Geocerca', key: 'geocerca_inicio' },
    ];

    const convertToCSV = (data) => {
        // Define the mapping between the table headers and the object keys in `data`
        const headerMapping = {
            patent: 'Patente',
            name: 'Nombre',
            surname: 'Apellido',
            ultimo_registro: 'Último registro',
            geocerca_inicio: 'Geocerca'
        };

        if (data.length === 0) {
            return '';
        }

        const headers = Object.values(headerMapping).join(',') + '\n';
        const rows = data.map(row => {
            return Object.keys(headerMapping).map(key => {
                let value = row[key];

                // Handle null or undefined values
                if (value === null || value === undefined) {
                    value = ''; // Replace null/undefined with an empty string
                } else if (!isNaN(value) && typeof value === 'number' && value.toString().includes('.')) {
                    // If it's a number with a dot, replace the dot with a comma
                    value = value.toString().replace('.', ',');
                }

                return `"${value}"`; // Apply text formatting to all fields
            }).join(',');
        }).join('\n');

        return headers + rows;
    };

    const downloadCSV = (csvContent, fileName = 'download.csv') => {
        // Create a Blob with the CSV content
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        // Create a hidden link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);

        // Append link to the body, click it, and then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDownload = () => {
        const csv = convertToCSV(estado_turno_prev);

        downloadCSV(csv, 'Camiones.csv');
    };

    const { rows, headers } = useSorting(filteredRows, _headers);
    const paginatedRows = rows.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    return (
        <DataTable rows={paginatedRows} headers={headers} width="100%">
            {({ rows: tableRows, headers: tableHeaders, getHeaderProps, getRowProps, getTableProps, getTableContainerProps, sortBy }) => (
                <TableContainer {...getTableContainerProps()}>
                    <TableToolbar>
                        <TableToolbarContent>
                            {/* pass in `onInputChange` change here to make filtering work */}
                            <Button onClick={handleDownload} >Descargar</Button>
                        </TableToolbarContent>
                    </TableToolbar>
                    <Table {...getTableProps()} aria-label="fuel table">
                        <TableHead>
                            <TableRow>
                                {headers.map((header, i) => <TableHeader
                                    key={i}
                                    sortDirection={_headers[i]?.sortDirection ?? "NONE"}
                                    {...getHeaderProps({
                                        header,
                                        isSortable: (_headers[i]?.sortDirection ?? "NONE") !== "NONE",
                                        onClick: (_, sortState) => sortBy(sortState.sortHeaderKey)
                                    })}>
                                    {header.header}
                                </TableHeader>)}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows.map(row => {
                                const { key, ...rowProps } = getRowProps({ row });
                                return (
                                    <TableRow key={key} {...rowProps}>
                                        {row.cells.map(cell => (
                                            <TableCell key={cell.id}>{cell.value}</TableCell>
                                        ))}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    <Pagination
                        totalItems={rows.length}
                        pageSizes={[PAGE_SIZE]}
                        pageSize={PAGE_SIZE}
                        page={page}
                        itemsPerPageText="Filas por página"
                        itemRangeText={(min, max) => `${min}–${max} filas`}
                        pageRangeText={(current, total) => `${current} de ${total}`}
                        forwardText="Página siguiente"
                        backwardText="Página anterior"
                        onChange={({ page }) => setPage(page)}
                    />
                </TableContainer>
            )}
        </DataTable>
    );
};

export default PerformancePreviousTurn;